import { render, staticRenderFns } from "./StockMenu.vue?vue&type=template&id=a5a97124"
import script from "./StockMenu.vue?vue&type=script&lang=js"
export * from "./StockMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports